import {
    Tabs,
    TabsHeader,
    TabsBody,
    Tab,
    TabPanel,
  } from "@material-tailwind/react";
import IrpBenefits from "./IrpBenefits";
import IrpFeautures from "./IrpFeautures";
import IrpObjectives from "./IrpObjectives";
   
  export default function IrpTabs() {
    const data = [
      {
        label: "Key Objectives",
        value: "objectives",
        desc: <IrpObjectives/>,
      },
      {
        label: "Key Features",
        value: "Key Features",
        desc: <IrpFeautures/>,
      },
      {
        label: "Key Benefits",
        value: "Key Benefits",
        desc: <IrpBenefits/>,
      },

    ];
   
    return (
      <div className="text-ternary-dark dark:text-ternary-light ">
      <Tabs value="html" className="max-w-[40rem] ">
        <TabsHeader
          className="bg-transparent text-ternary-dark dark:text-ternary-light "
          indicatorProps={{
            className: "bg-blue-500/10 shadow-none text-blue-500",
          }}
        >
          {data.map(({ label, value }) => (
            <Tab key={value} value={value}>
              {label}
            </Tab>
          ))}
        </TabsHeader>
        <TabsBody>
          {data.map(({ value, desc }) => (
            <TabPanel key={value} value={value}>
              {desc}
            </TabPanel>
          ))}
        </TabsBody>
      </Tabs>
      </div>
    );
  }